<template>
  <div>
    <TwcLabel class="font-semibold mb-1">
      {{ $props.label }}
    </TwcLabel>
    <div
      class="grid grid-cols-3 bg-white h-12 w-full border border-solid border-gray-200 rounded-lg"
    >
      <TwcButton flat data-testid="decrease" class="text-xl" @click="decrease"> - </TwcButton>
      <span class="flex items-center justify-center text-xl" data-testid="quantity">
        {{ model }}
      </span>
      <TwcButton flat data-testid="increase" class="text-xl" @click="increase"> + </TwcButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { TwcLabel, TwcButton } from 'transit-web-components'

const emit = defineEmits(['change'])
const props = defineProps({
  id: {
    type: String,
    required: true
  },
  label: {
    type: String,
    required: true
  },
  minValue: {
    type: Number,
    required: false,
    default: 0
  },
  maxValue: {
    type: Number,
    required: false,
    default: Infinity
  },
  allowIncrease: {
    type: Boolean,
    required: false,
    default: true
  }
})

const model = defineModel({
  default: 0,
  type: Number
})

function increase() {
  const oldValue = model.value
  if (props.allowIncrease) {
    model.value = Math.min(model.value + 1, props.maxValue)
  }
  emit('change', props.id, model.value, oldValue)
}

function decrease() {
  const oldValue = model.value
  model.value = Math.max(model.value - 1, props.minValue)
  emit('change', props.id, model.value, oldValue)
}

onMounted(() => {
  model.value = props.minValue
})
</script>

<style scoped></style>
